export default {
  contractActivity: {
    contractActivity: {
      title: ({ plural }) => plural(["Activity", "Activities"]),
      type: {
        professional: "Company",
        pedagogic: "Training",
      },
      tabs: {
        description: "Description",
        document: "Attachments",
      },
      status: {
        complete: "Complete",
        to_complete: "To complete",
      },
      context: "Context",
      description: "Tasks completed",
      difficulties_encountered: "Difficulties & solutions",
      results_obtained: "Results obtained",
      analysis_and_learning: "Analysis & learning",
      tools: "Tools & technologies",
      skills: "Related skills",
      autonomy_complexity: "Autonomy & complexity",
      missions: "Related missions",
      no_activities: "No activity is defined on this contract.",
      no_activities_filtered: "No activity matches the selected filter.",
      relatedSkills: {
        launch_analysis: "Run analysis",
        relaunch_analysis: "Re-run analysis",
        badge_default: "AI skills analysis",
        badge_with_date: ({ named }) => `Reference ${named("code")} — Analysis performed on ${named("date")}`,
        badge_no_date: ({ named }) => `Reference ${named("code")}`,
        no_activity_id: "Save the activity first to access the skills.",
        no_analysis: "Click « Run analysis » to identify the skills mobilised in this activity.",
        analysing: "Analysis in progress, please wait…",
        ai_analysis: "AI analysis of the match between the activity and the skills block",
        summary_title: "AI analysis of the match between the activity and the skills",
        validated: "Validated",
        to_validate: "To validate",
        validate_all_proposals: "Validate the activity/skills relationship",
        add_block_picker_title: "Manually add skills blocks",
        add_block_confirm: "Add selected blocks",
        selected_skills_count: ({ named }) => `${named("count")} skill${named("count") <= 1 ? "" : "s"} selected`,
        collapsed_selected_skills_heading: "Selected skills",
        skill_status_selected: "Selected skill",
        skill_status_validated: "Validated skill",
      },
      annexes: {
        count: ({ named }) => `${named("count")} attachment${named("count") === 1 ? "" : "s"} linked to this activity`,
        technical_documents: "Technical documents",
        screenshots_photos: "Screenshots & photos",
        empty: "No attachment linked to this activity.",
      },
    },
  },
};
